import { Takk, takkSchema } from "@mjolnerbacken/shared/types/takk";
import { TakkCreate } from "@mjolnerbacken/shared/types/takk-create";

import { deleteRequest, getRequest, postRequest } from "../utils/request";

const API_BASE_URL = process.env.API_BASE_URL || "/api";

export function getTakk(): Promise<Takk[]> {
  return getRequest(`${API_BASE_URL}/takk`, takkSchema.array());
}

export async function createTakk(takk: TakkCreate): Promise<void> {
  await postRequest(`${API_BASE_URL}/takk`, takk);
}

export async function deleteTakk(id: string): Promise<void> {
  await deleteRequest(`${API_BASE_URL}/takk/${id}`);
}
